import React from 'react'
export const getLinariaClassName = (component: React.FC) =>
  // @ts-expect-error property doesn't exist
  component?.__wyw_meta?.className
